module.exports = __webpack_public_path__ + "static/media/deleteIcon.3a95739f.svg";